import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import type * as React from 'react';

import { cn } from 'src/lib/utils';

const Checkbox = ({
  className,
  ref,
  ...props
}: (React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  className?: string;
}) & {
  ref?: React.Ref<React.ComponentRef<typeof CheckboxPrimitive.Root>>;
}) => (
  <CheckboxPrimitive.Root
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-xs border border-border-default focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-default data-[state=checked]:text-primary-foreground dark:border-border-default dark:ring-offset-border-default dark:data-[state=checked]:bg-primary-default dark:data-[state=checked]:text-primary-foreground dark:focus-visible:ring-slate-300',
      className,
    )}
    ref={ref}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <Check className='h-4 w-4' />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
